import Vue from 'vue'
import SubPage from './sub-page'
import clientEnv from '@/utils/clientEnv'
import { app } from '@/utils/'

let SubPageTem = Vue.extend(SubPage)
let instance

let subPage = options => {
  const { url } = options
  app.openTopNewWebview({
    url,
    header: true,
    error() {
      if (clientEnv.isIOS) {
        location.href = options.url
      } else if (clientEnv.isVivoApp) {
        location.replace(options.url)
      } else {
        if (!instance) {
          instance = new SubPageTem()
          instance.position = 'right'
          instance.vm = instance.$mount()
          document.body.appendChild(instance.vm.$el)
        }
        instance.url = options.url
        instance.show = true
      }
    }
  })
}
subPage.close = () => {
  instance && (instance.show = false)
}
Vue.prototype.$subPage = subPage
export default subPage
